import { render } from "./AppGecrosAccess.vue?vue&type=template&id=25643716&scoped=true"
import script from "./AppGecrosAccess.vue?vue&type=script&lang=js"
export * from "./AppGecrosAccess.vue?vue&type=script&lang=js"

import "./AppGecrosAccess.vue?vue&type=style&index=0&id=25643716&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25643716"]])

export default __exports__